import { useState, useEffect } from 'react'
import { apiService } from '../services/api'
import { TimelineEntry } from '../components/ui'

export const useVehicleHistory = (vehicleId?: string) => {
  const [history, setHistory] = useState<TimelineEntry[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!vehicleId) {
      setHistory([])
      return
    }

    const fetchHistory = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const response = await apiService.getVehicleHistory(vehicleId)

        // Transform backend response to TimelineEntry format
        const entries: TimelineEntry[] = response.map((item: any) => ({
          id: item.id,
          type: item.type,
          userName: item.user?.name,
          userEmail: item.user?.email,
          timestamp: item.createdAt,
          fromStatus: item.fromStatus,
          toStatus: item.toStatus,
          metadata: item.metadata,
        }))

        setHistory(entries)
      } catch (err: any) {
        console.error('Erro ao carregar histórico do veículo:', err)
        setError(err.message || 'Erro ao carregar histórico')
      } finally {
        setIsLoading(false)
      }
    }

    fetchHistory()
  }, [vehicleId])

  return { history, isLoading, error }
}
